export default __webpack_public_path__ + "static/media/blue.66680a56.png";